import {
  Component, OnInit, ViewChild, Input, Output,
  EventEmitter, Renderer2, SimpleChanges
} from '@angular/core';
import { GridLine, GridComponent } from '@syncfusion/ej2-angular-grids';
import { FormArray, FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from '../shared-imports';

@Component({
  selector: 'app-select-template',
  templateUrl: './select-template.component.html',
  styleUrls: ['./select-template.component.scss'],
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES]
})
export class SelectTemplateComponent implements OnInit {
  @Output() ListOfActiveMarkets = new EventEmitter<any>();
  @Input() AllData = [];
  @Input() ActiveFormArray: FormArray;
  @Input() public SelectionName;
  @Output() isFormDirty: EventEmitter<any> = new EventEmitter<any>();

  ActiveData = [];
  ActiveHeader = '';
  AllDataHeader = '';
  tempAllData = [];
  tempActiveGridData = [];
  masterFilterActiveData = [];
  AllFilterData = [];
  AllDataDisplay = [];
  ActiveDataDisplay = [];
  ActiveFilterData = [];
  activeRecords: Object[];
  isFilterAll: boolean;
  isFilterActive: boolean;
  records: Object[];
  public lines: GridLine;
  public activedataSubject : BehaviorSubject<any>;
  @ViewChild('gridAlldata', { static: false })
  public gridAlldata: GridComponent;
  @ViewChild('gridActiveData', { static: false })
  public gridActiveData: GridComponent;
  @ViewChild('gridAllTaxData', { static: true })
  public gridAllTaxData: GridComponent;
  @ViewChild('gridActiveTaxData', { static: true })
  public gridActiveTaxData: GridComponent;
  isOninitExecuted = false;

  constructor(public formBuilder: FormBuilder,
    public rendrer: Renderer2) { 
      
    }

  stores = [];

  ngOnInit() {
    if (this.SelectionName === 'Marketselection') {
      this.ActiveHeader = 'Active Markets';
      this.AllDataHeader = 'Available Markets';
    }
    this.lines = 'Both';
    this.ActiveData = [];
    this.isOninitExecuted = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    
    this.loadActiveTable();
    
  }

  loadActiveTable() {
    
    this.AllDataDisplay= [];
    this.ActiveData = [];
    this.tempAllData = this.AllData;
    
    for (let i = 0; i < this.ActiveFormArray.controls.length; i++) {
      const cnt = this.ActiveFormArray.controls[i];
      this.ActiveData.push(this.ActiveFormArray.controls[i].value);
      console.log(this.ActiveFormArray.controls[i].value);
    }

    this.AllData = this.removeAllData(this.ActiveData, this.AllData);   
    this.AllDataDisplay = this.AllData;
    this.ActiveDataDisplay = this.ActiveData;

    this.hidePercentageFilter();
  }


  populateActiveList() {
    var tempAllList = [];
    let tempActiveobj = [];
    this.ActiveData = this.ActiveData.filter((element) => {
      const tempPos = tempAllList.findIndex(o => o.Id === element.Id);
      if (tempPos !== -1) {
        tempActiveobj.push(tempAllList[tempPos]);
      }
    });
    this.ActiveData = tempActiveobj;
    
    if (  this.AllData.length === 0) {
      this.AllData = tempAllList;
    }
    
  }

  removeAllData(obj, allArray) {
   
      obj.filter((ele) => {
        const objtax = allArray.findIndex(o => o.Id === ele.Id);
        if (objtax !== -1) {
          allArray = [...allArray.slice(0, objtax), ...allArray.slice(objtax + 1)];
        }
      });
      this.tempAllData = allArray;
      return allArray;
    
  }

  addToActiveGrid() {
    const selectedrecords = this.gridAlldata.getSelectedRecords();  // Get the selected records.
    this.records = selectedrecords;
    if (this.records.length !== 0) {
      this.ActiveData = this.ActiveData.concat(this.records);
      this.tempActiveGridData = this.ActiveData;
      this.insertFormArrayData(this.ActiveFormArray, this.records);
      this.removeFromAllData(this.records);
      this.isFormDirty.emit(true);
      this.ActiveFilterData = this.ActiveData;
      
      if (this.isFilterAll === true) {
        this.removeFromAllDataDisplay(this.records);
      } else {
        this.AllDataDisplay = this.AllData;
      }
      if (this.isFilterActive !== true) {
        this.ActiveDataDisplay = this.ActiveData;
        //should remove the selected item- from allDatadisplay: if filter is applied and item moved
      } else {
        //this.loadToActiveGrid(this.gridFilterStoreActivedata, 'filter');
      }
      this.records = [];
      this.masterFilterActiveData = this.tempActiveGridData;
      this.hidePercentageFilter();
    }
  }

  insertFormArrayData(formArray: FormArray, records) {
    for (let k = 0; k < records.length; k++) {
      formArray.push(this.formBuilder.control(records[k]));
    }
  }


  removeFromAllData(obj) {
    let i;
    for (i = 0; i < obj.length; i++) {
        const id = obj[i].Id;
        const objtax = this.AllData.findIndex(o => o.Id === id);
        this.AllData = [...this.AllData.slice(0, objtax), ...this.AllData.slice(objtax + 1)];
    }
  }

  removeFromAllDataDisplay(obj) {
    let i;
    for (i = 0; i < obj.length; i++) {
        const id = obj[i].Id;
        const objtax = this.AllDataDisplay.findIndex(o => o.Id === id);
        this.AllDataDisplay = [...this.AllDataDisplay.slice(0, objtax), ...this.AllDataDisplay.slice(objtax + 1)];
    }
    this.gridAlldata.refresh();
  }

  addToAllGrid() {
    const selectedrecords = this.gridActiveData.getSelectedRecords();  // Get the selected records.
    this.activeRecords = selectedrecords;
    if (this.activeRecords.length !== 0) {
      this.AllData = this.AllData.concat(this.activeRecords);
      this.removeFromActiveData(this.activeRecords);

      this.AllFilterData = this.AllData;
      this.isFormDirty.emit(true);
      
      if (this.isFilterAll !== true) {
        this.AllDataDisplay = this.AllData;
      }
      if (this.isFilterActive === true) {
        this.removeFromActiveDataDisplay(this.activeRecords);
      } else {
        this.ActiveDataDisplay = this.ActiveData;
      }
      this.activeRecords = [];
      this.hidePercentageFilter();
    }
    if(this.ActiveDataDisplay.length == 0){
      this.RefreshActive();
    }
  }


  removeFromActiveData(obj) {
    let i;
    for (i = 0; i < obj.length; i++) {
        const id = obj[i].Id;
        const objtax = this.ActiveData.findIndex(o => o.Id === id);
        const result = this.ActiveData.slice(0, objtax).concat(this.ActiveData.slice(objtax + 1));
        this.addTotempActiveGrid(id);
        this.ActiveData = result;
    }
    this.removeFormArrayData(this.ActiveFormArray, this.activeRecords);
    this.gridActiveData.refresh();
  }

  
  removeFromActiveDataDisplay(obj) {
    let i;
    for (i = 0; i < obj.length; i++) {
        const id = obj[i].Id;
        const objtax = this.ActiveDataDisplay.findIndex(o => o.Id === id);
        const result = this.ActiveDataDisplay.slice(0, objtax).concat(this.ActiveDataDisplay.slice(objtax + 1));
        this.ActiveDataDisplay = result;
    }
    this.gridActiveData.refresh();
  }

  addTotempActiveGrid(id) {
    let obj;
    obj = this.tempActiveGridData.findIndex(o => o.Id === id);
    this.tempActiveGridData = this.tempActiveGridData.slice(0, obj).concat(this.tempActiveGridData.slice(obj + 1));
    this.masterFilterActiveData = this.masterFilterActiveData.slice(0, obj).concat(this.masterFilterActiveData.slice(obj + 1)); 
  }
  
  removeFormArrayData(formArray: FormArray, records): Promise<void> {
    
    return new Promise<void>((resolve) => {
    for (let k = 0; k < records.length; k++) {
        formArray.removeAt(formArray.value.findIndex(obj => obj.Id === records[k].Id));
    }
    resolve();
  });
  }

  hidePercentageFilter() {
   
  }

  async RefreshActive(){
    await new Promise(resolve => setTimeout(resolve, 200)); //0.1 sec wait to finish grid function
    this.gridActiveData.refresh();
  }

}